// extracted by mini-css-extract-plugin
export default {"error-message":"ErrorMessage_error-message__RDOtL"};